export const DEFAULT_AUDIO_VOLUME_LEVEL = 0.5;
